"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiSelect = MultiSelect;

var React = _interopRequireWildcard(require("react"));

var _core = require("@blueprintjs/core");

var _select = require("@blueprintjs/select");

var _index2 = require("../../index");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var defaultTagRenderer = function defaultTagRenderer(item) {
  return item.label;
};

var itemPredicate = function itemPredicate(query, item, _index, exactMatch) {
  var normalizedLabel = item.label.toLowerCase();
  var normalizedQuery = query.toLowerCase();

  if (exactMatch) {
    return normalizedLabel === normalizedQuery;
  }

  return "".concat(normalizedLabel).indexOf(normalizedQuery) >= 0;
};

function MultiSelect(_ref) {
  var _multiSelectProps$tag, _multiSelectProps$tag2;

  var className = _ref.className,
      disabled = _ref.disabled,
      fill = _ref.fill,
      handleChange = _ref.handleChange,
      loading = _ref.loading,
      intent = _ref.intent,
      items = _ref.items,
      usePortal = _ref.usePortal,
      allowCreateNewItems = _ref.allowCreateNewItems,
      placeholder = _ref.placeholder,
      selectedItems = _ref.selectedItems,
      condensed = _ref.condensed,
      tagRenderer = _ref.tagRenderer,
      multiSelectProps = _objectWithoutProperties(_ref, ["className", "disabled", "fill", "handleChange", "loading", "intent", "items", "usePortal", "allowCreateNewItems", "placeholder", "selectedItems", "condensed", "tagRenderer"]);

  var _React$useState = React.useState(selectedItems || []),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      internalSelectedItems = _React$useState2[0],
      setInternalSelectedItems = _React$useState2[1];

  React.useEffect(function () {
    // on receiving new selectedItems props
    if (selectedItems) setInternalSelectedItems(selectedItems);
  }, [selectedItems]);

  var handleItems = function handleItems(newItems) {
    setInternalSelectedItems(function () {
      if (handleChange) handleChange(newItems);
      return newItems;
    });
  };

  function handleClear() {
    handleItems([]);
  }

  var itemRenderer = function itemRenderer(item, _ref2) {
    var modifiers = _ref2.modifiers,
        handleClick = _ref2.handleClick,
        index = _ref2.index;
    if (!modifiers.matchesPredicate) return null;
    var isSelected = isItemSelected(item);
    return /*#__PURE__*/React.createElement(_core.MenuItem, {
      active: modifiers.active,
      disabled: modifiers.disabled,
      icon: /*#__PURE__*/React.createElement(_index2.Icon16, {
        fill: isSelected ? _index2.Colors.SAGE_50 : _index2.Colors.GREY_50,
        style: {
          fill: isSelected ? _index2.Colors.SAGE_50 : _index2.Colors.GREY_50
        },
        icon: isSelected ? _index2.IconNames16.CHECKED : _index2.IconNames16.UNCHECKED
      }),
      onClick: handleClick,
      key: "".concat(item.value, "_").concat(index),
      text: item.label,
      textClassName: isSelected ? _index2.Classes.ACTIVE : undefined,
      shouldDismissPopover: false
    });
  };

  function isItemSelected(item) {
    return internalSelectedItems.includes(item);
  }

  function deselectItem(item) {
    handleItems(internalSelectedItems.filter(function (i) {
      return i !== item;
    }));
  }

  var handleItemSelect = function handleItemSelect(item) {
    if (isItemSelected(item)) {
      deselectItem(item);
    } else {
      handleItems([item].concat(_toConsumableArray(internalSelectedItems)));
    }
  };

  var handleTagRemove = function handleTagRemove(label, index) {
    var item = internalSelectedItems.find(function (selectedItem, selectedItemIndex) {
      return selectedItemIndex === index && selectedItem.label === label;
    });
    deselectItem(item);
  };

  var createNewItemFromQuery = function createNewItemFromQuery(query) {
    // (TimKrins) I know I am allowed to return null here so just let me do it please thanks
    if (query.length < 2) return null;
    return {
      label: query,
      value: query
    };
  };

  var createNewItemRenderer = function createNewItemRenderer(query, active, handleClick) {
    return /*#__PURE__*/React.createElement(_core.MenuItem, {
      active: active,
      disabled: false,
      onClick: handleClick,
      text: "Create '".concat(query, "'"),
      shouldDismissPopover: false
    });
  };

  var noResults = /*#__PURE__*/React.createElement(_core.MenuItem, {
    disabled: true,
    text: allowCreateNewItems ? 'Type to add option...' : 'No results.'
  });
  /**
   * It's important that we don't use a portal if we're nested
   * within a Dialog. Refer to the `usePortal` docs.
   * @see https://blueprintjs.com/docs/#core/components/dialog
   */

  var turbolinksFixPortalDocumentBody = document.body;

  var popoverProps = _objectSpread(_objectSpread({}, multiSelectProps.popoverProps), {}, {
    fill: fill,
    minimal: true,
    position: _index2.Position.BOTTOM_LEFT,
    portalContainer: turbolinksFixPortalDocumentBody,
    usePortal: usePortal !== undefined ? usePortal : true
  });

  var hasSelectedItems = internalSelectedItems.length > 0;
  var condensedPlaceholder = internalSelectedItems.length === 1 ? '1 item' : "".concat(internalSelectedItems.length, " items");
  /**
   * For condensed multi selects we need to make sure we add a condensed class when we've got selected items
   * Not necessarily the best name but indicates that the placeholder text should be a darker colour
   *
   * For the tagInputClass - yes its horrible but I need to be able to pass through classes like Classes.FORCE_HOVER
   * for use in the stories
   */

  var tagInputClass = (multiSelectProps === null || multiSelectProps === void 0 ? void 0 : (_multiSelectProps$tag = multiSelectProps.tagInputProps) === null || _multiSelectProps$tag === void 0 ? void 0 : _multiSelectProps$tag.className) || '';

  var baseTagInputProps = _objectSpread(_objectSpread({
    disabled: disabled
  }, multiSelectProps.tagInputProps), {}, {
    onRemove: handleTagRemove,
    tagProps: (multiSelectProps === null || multiSelectProps === void 0 ? void 0 : (_multiSelectProps$tag2 = multiSelectProps.tagInputProps) === null || _multiSelectProps$tag2 === void 0 ? void 0 : _multiSelectProps$tag2.tagProps) || {
      round: true
    },
    className: (0, _classnames.default)(_defineProperty({}, _index2.Classes.CONDENSED, condensed && hasSelectedItems), _defineProperty({}, tagInputClass, tagInputClass))
  });
  /**
   * Loading spinner always takes precedence as a right element
   * If condensed and we have selected items then ensure we add a button to clear the select box easily
   */


  var tagInputProps = loading ? _objectSpread(_objectSpread({}, baseTagInputProps), {}, {
    rightElement: /*#__PURE__*/React.createElement(_index2.Spinner, {
      small: true
    })
  }) : condensed && hasSelectedItems ? _objectSpread(_objectSpread({}, baseTagInputProps), {}, {
    rightElement: /*#__PURE__*/React.createElement(_index2.IconButton24, {
      icon: _index2.IconNames8.CROSS,
      onClick: handleClear
    })
  }) : baseTagInputProps;
  var classes = (0, _classnames.default)(_defineProperty({}, _index2.Classes.intentClass(intent), intent), _defineProperty({}, _index2.Classes.ACTIVE, condensed && hasSelectedItems), className);
  return /*#__PURE__*/React.createElement(_select.MultiSelect, _extends({
    className: classes
  }, multiSelectProps, {
    items: items,
    itemPredicate: itemPredicate,
    itemRenderer: itemRenderer,
    popoverProps: popoverProps,
    tagInputProps: tagInputProps,
    tagRenderer: condensed ? function () {
      return null;
    } : tagRenderer || defaultTagRenderer,
    createNewItemRenderer: createNewItemRenderer,
    noResults: noResults,
    placeholder: condensed && hasSelectedItems ? condensedPlaceholder : placeholder,
    selectedItems: internalSelectedItems,
    createNewItemFromQuery: allowCreateNewItems ? createNewItemFromQuery : undefined,
    onItemSelect: handleItemSelect
  }));
}